import fetch from '../../../../utils/fetch'

const initialState = {
    isLoading: false,
    error: null,

    likesTotal: null,
    likesLastMonth: null,
    locationsTotal: null,
    locationsLastMonth: null,
    observationsRecordsTotal: null,
    observationsRecordsLastMonth: null,
    observationsTotal: null,
    observationsLastMonth: null,
    postsTotal: null,
    postsLastMonth: null,
    picturesTotal: null,
    picturesLastMonth: null,
    projectsTotal: null,
    projectsLastMonth: null,
}

const getters = {

}

const actions = {
    /**
     * @function getProject - retrieve from API project data
     * @param commit
     * @param rootGetters
     * @returns {Promise<T | never> | * | *}
     */
    get({ commit, rootGetters }) {
        commit(types.RESET)
        commit(types.SET_PROFILE_STATS_LOADING);
        return fetch('/users/' + rootGetters['user/profile/id'] + '/stats')
            .then(response => response.json())
            .then((data) => {
                commit(types.SET_PROFILE_STATS, data)
            })
            .catch((error) => {
                commit(types.SET_PROFILE_STATS_ERROR, error.message)
            })
    },
}

const types = {
    SET_PROFILE_STATS_LOADING: 'SET_PROFILE_STATS_LOADING',
    SET_PROFILE_STATS: 'SET_PROFILE_STATS',
    SET_PROFILE_STATS_ERROR: 'SET_PROFILE_STATS_ERROR',
    RESET_ERROR: 'RESET_ERROR',
    RESET: 'RESET',
}

const mutations = {
    [types.SET_PROFILE_STATS_LOADING](state) {
        state.isLoading = true;
        state.error = false;
    },
    [types.SET_PROFILE_STATS](state, stats) {
        state.likesTotal = stats.likesTotal
        state.likesLastMonth = stats.likesLastMonth
        state.locationsTotal = stats.locationsTotal
        state.locationsLastMonth = stats.locationsLastMonth
        state.observationsRecordsTotal = stats.observationsRecordsTotal
        state.observationsRecordsLastMonth = stats.observationsRecordsLastMonth
        state.observationsTotal = stats.observationsTotal
        state.observationsLastMonth = stats.observationsLastMonth
        state.postsTotal = stats.postsTotal
        state.postsLastMonth = stats.postsLastMonth
        state.picturesTotal = stats.picturesTotal
        state.picturesLastMonth = stats.picturesLastMonth
        state.projectsTotal = stats.projectsTotal
        state.projectsLastMonth = stats.projectsLastMonth

        state.isLoading = false;
    },
    [types.SET_PROFILE_STATS_ERROR](state, error) {
        state.error = error;
        state.isLoading = false;
    },
    [types.RESET_ERROR](state) {
        state.isLoading = false;
        state.error = false;
    },
    [types.RESET](state) {
        state = initialState
    },
}

export default {
    namespaced: true,
    state: initialState,
    getters: getters,
    actions: actions,
    mutations: mutations
}
